var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "newsletter" }, [
    _c("p", { staticClass: "subtitle-normal newsletter-title" }, [
      _vm._v(_vm._s(_vm.umbracoContent.modelContent)),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "subscribe-form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitSubscribeForm.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "form-row" }, [
          !_vm.formSubmitted
            ? _c("div", { staticClass: "col-md-6 col-lg-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    placeholder: "Jouw e-mailadres",
                    type: "email",
                    name: "email",
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.formError
                  ? _c("small", { staticClass: "form-text text-error" }, [
                      _vm._v("Er is iets fout gegaan, probeer het opnieuw"),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.formSubmitted
            ? _c("div", { staticClass: "col-xs" }, [
                _c(
                  "div",
                  { staticClass: "button-wrap d-flex align-items-end h-100" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "submit-button btn btn-lg btn-white roll-button rollover",
                        attrs: { type: "submit" },
                      },
                      [
                        _c("span", { staticClass: "roll-text" }, [
                          _vm._v(_vm._s(_vm.umbracoContent.buttonText)),
                          _c("svg", { staticClass: "icon icon-arrow--right" }, [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-arrow--right" },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "roll-text" }, [
                          _vm._v(_vm._s(_vm.umbracoContent.buttonText)),
                          _c("svg", { staticClass: "icon icon-arrow--right" }, [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-arrow--right" },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.formSubmitted
          ? _c("p", { staticClass: "newsletter-success" }, [
              _vm._v("Bedankt voor je inschrijving"),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }